module.exports = __webpack_public_path__ + "static/media/18kinhdoanh.e66ff76e.jpg";